import { FC } from "react";

import './Loader.scss';

interface iProps {
	fullScreen?: boolean;
}


const Loader: FC<iProps> = ({fullScreen}) => {

	return (
		<div className={fullScreen? "LoaderWrapper" : ''}>
			<div className="Loader"/>
		</div>
	)
}

export default Loader;